<div class="diary-work-route-preview" [class.diary-work-route-preview--clickable]="hasGeometry">
  <div
    #mapContainer
    class="diary-work-route-preview__map"
    [attr.role]="hasGeometry ? null : 'img'"
    [attr.aria-label]="hasGeometry ? null : 'Náhled polohy prací na mapě'"
  ></div>
  <button
    *ngIf="hasGeometry"
    type="button"
    class="diary-work-route-preview__hit-area"
    (click)="openExpanded()"
    aria-label="Zobrazit mapu"
  ></button>
  <p *ngIf="!hasGeometry" class="diary-work-route-preview__status text-xs text-neutral-500">
    Poloha není k dispozici.
  </p>
</div>

<div
  *ngIf="expanded"
  #overlayRoot
  class="diary-work-route-preview__overlay"
  (click)="closeExpanded()"
>
  <div class="diary-work-route-preview__dialog" (click)="$event.stopPropagation()">
    <div class="diary-work-route-preview__dialog-header">
      <span class="text-sm font-medium text-neutral-900 dark:text-neutral-100">Trasa prací</span>
      <button
        type="button"
        class="diary-work-route-preview__close"
        (click)="closeExpanded()"
        aria-label="Zavřít"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <div #modalMapContainer class="diary-work-route-preview__modal-map"></div>
  </div>
</div>
